export const TRANSITION_TIME_TOTAL = 600;
export const TRANSITION_TIME_ENTER = (TRANSITION_TIME_TOTAL / 2);
export const TRANSITION_TIME_LEAVE = (TRANSITION_TIME_TOTAL / 2);
export const TRANSITION_TIME_GRADIENT = TRANSITION_TIME_TOTAL;

export const NAV_TRANSITION_TIME = 700;
export const NAV_TRANSITION_DELAY = 150;
